import { render, staticRenderFns } from "./AreaPicker.vue?vue&type=template&id=3fc89a40&scoped=true&"
import script from "./AreaPicker.vue?vue&type=script&lang=js&"
export * from "./AreaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc89a40",
  null
  
)

export default component.exports